import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { articles } from '../data/articles.js'
import SEO from '../components/SEO'

export default function BlogPage() {
  return (
    <div className="min-h-screen px-4 pt-32 pb-24" style={{ background: '#050510' }}>
      <SEO 
        title="Nerd Blog | Patch Notes per la Vita Reale"
        description="Guide, teorie e patch notes per il tuo sistema operativo umano. Scritte in linguaggio nerd e testate nel mondo reale su procrastinazione, sonno, stress e focus."
      />
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h1 className="font-display text-4xl md:text-5xl font-bold text-gradient mb-4">
            NERD BLOG
          </h1>
          <p className="text-nerd-gray text-lg max-w-2xl mx-auto leading-relaxed">
            Guide, teorie e patch notes per il tuo sistema operativo umano. Scritte in linguaggio nerd, testate nel mondo reale.
          </p>
        </motion.div>

        <div className="grid gap-8 md:grid-cols-2">
          {articles.map((article, index) => (
            <motion.article
              key={article.slug}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative rounded-xl overflow-hidden border border-nerd-purple/10 hover:border-nerd-cyan/30 transition-colors flex flex-col"
              style={{ background: 'rgba(10,10,30,0.6)' }}
            >
              <Link to={`/blog/${article.slug}`} className="block flex-1 flex flex-col">
                {/* Article Card Image */}
                {article.image && (
                  <div className="relative h-52 w-full overflow-hidden" style={{ borderBottom: '1px solid rgba(139,92,246,0.15)' }}>
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#050510]/80 to-transparent pointer-events-none" />
                  </div>
                )}
                
                <div className="p-6 md:p-8 flex-1 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-3 mb-4">
                      <span className="text-nerd-cyan text-xs font-display uppercase tracking-wider">
                        {article.date}
                      </span>
                      <span className="text-nerd-gray/50 text-xs">·</span>
                      <span className="text-nerd-gray/50 text-xs">
                        {article.readTime} di lettura
                      </span>
                    </div>

                    <h2 className="font-display text-xl md:text-2xl font-bold text-nerd-white mb-3 group-hover:text-nerd-cyan transition-colors leading-tight">
                      {article.title}
                    </h2>

                    <p className="text-nerd-gray text-sm leading-relaxed mb-6">
                      {article.excerpt}
                    </p>
                  </div>

                  <div>
                    <div className="flex flex-wrap gap-2">
                      {article.tags.map((tag) => (
                        <span
                          key={tag}
                          className="text-xs px-3 py-1 rounded-full border border-nerd-purple/20 text-nerd-gray/70"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>

                    <div className="mt-6 flex items-center text-nerd-cyan text-sm font-display uppercase tracking-wider group-hover:translate-x-1 transition-transform">
                      Leggi l'articolo
                      <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </div>
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </div>
  )
}
